module.exports = __webpack_public_path__ + "img/流程设计_03.e4c834ac.svg";